export default __webpack_public_path__ + "static/media/home_screen.c498bdf5.png";